// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageCarouselStyles } from "@awc/Overrides/Components/ProductImageCarousel";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

const getImageCss = (isSelected: boolean) => css`
    border: 1px solid ${isSelected ? color("common.black") : "transparent"};
    cursor: pointer;
    justify-content: flex-start;
    &,
    img {
        width: 44px;
        height: 44px;
        aspect-ratio: 1;
    }
`;

productImageCarouselStyles.carouselSlideInner = {
    css: css`
        width: 44px;
        height: 44px;
    `,
};

productImageCarouselStyles.carousel = {
    container: {
        css: css`
            .swiper-slide {
                width: 44px;
                height: 44px;
            }
        `,
    },
};

productImageCarouselStyles.image = {
    css: getImageCss(false),
};

productImageCarouselStyles.selectedImage = {
    css: getImageCss(true),
};

productImageCarouselStyles.carouselWrapper = {
    css: css`
        margin-top: 25px;
        .xng-pagination-container {
            margin-top: 12px !important;
        }
    `,
};
